import React from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getNexusTokens } from '../../theme/tokens';

/**
 * Standard create/edit dialog shell (Phase 7.2).
 */
export default function FormDialog({
  open,
  title,
  children,
  onClose,
  onSubmit,
  submitLabel = 'Save',
  cancelLabel = 'Cancel',
  submitColor = 'primary',
  loading = false,
  maxWidth = 'sm',
  fullWidth = true,
  disableSubmit = false,
  actions,
}) {
  const theme = useTheme();
  const tokens = getNexusTokens(theme);

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      PaperProps={{
        sx: {
          bgcolor: tokens.colors.surface.paper,
          color: tokens.colors.text.primary,
          border: `1px solid ${tokens.colors.border.default}`,
          borderRadius: tokens.radius.xl,
        },
      }}
    >
      {title ? (
        <DialogTitle sx={{ color: tokens.colors.text.primary, borderBottom: `1px solid ${tokens.colors.border.default}` }}>
          {title}
        </DialogTitle>
      ) : null}
      <DialogContent>{children}</DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        {actions ?? (
          <>
            <Button onClick={onClose} disabled={loading} sx={{ color: tokens.colors.text.muted }}>
              {cancelLabel}
            </Button>
            {onSubmit ? (
              <Button
                onClick={onSubmit}
                variant="contained"
                color={submitColor}
                disabled={loading || disableSubmit}
                startIcon={
                  loading ? <CircularProgress size={16} color="inherit" /> : null
                }
              >
                {submitLabel}
              </Button>
            ) : null}
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
